import React, { useState } from 'react';
import { updatePolicy } from '../api';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';

function PolicyUpdate() {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await updatePolicy(key, value);
      setMessage(data.message);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <Container className="py-4 d-flex justify-content-center">
      <Card className="shadow" style={{ width: '100%', maxWidth: '500px' }}>
        <Card.Body>
          <h4 className="mb-4 text-center">Update Policy</h4>
          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3" controlId="formKey">
              <Form.Label column sm={4}>Key</Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="text"
                  value={key}
                  onChange={(e) => setKey(e.target.value)}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formValue">
              <Form.Label column sm={4}>Value</Form.Label>
              <Col sm={8}>
                <Form.Control
                  type="text"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  required
                />
              </Col>
            </Form.Group>
            <Button type="submit" variant="primary" className="w-100">
              Update Policy
            </Button>
          </Form>
          {message && <Alert variant="info" className="mt-3">{message}</Alert>}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default PolicyUpdate;